import * as React from "react";
import { DevicesState } from "./DevicesNewReducer";

const DevicesStateContext = React.createContext<DevicesState>(undefined);

interface DevicesStateContextProviderProps {
    state: DevicesState;
    children: React.ReactNode;
}

export const DevicesStateContextProvider = ({ state, children }: DevicesStateContextProviderProps) => {
    return (
        <DevicesStateContext.Provider value={state}>
            {children}
        </DevicesStateContext.Provider>
    );
}

export const useDevicesStateContext = () => {
    const context = React.useContext(DevicesStateContext);
    if (context === undefined) {
        throw new Error('useDevicesStateContext must be used within a DevicesStateContext Provider')
    }

    return context;
}
